import { camelCase } from 'lodash';
import { uuid } from '../utils/crypto.util';

const transform = (text: string) => camelCase(text);

export function useFootnoteReference(componentId: string, tenantId = 'emh') {
  const finalTenantId = transform(tenantId);
  const finalComponentId = transform(componentId);
  const id = uuid();

  // Use componentId suffix and indexes in order to cover cases where a component has more than one
  // footnote usage or lists
  const generateReference = (componentIdSuffix?: string, index = 0): string => {
    return `${finalTenantId}_${finalComponentId}${componentIdSuffix ? transform(componentIdSuffix) : ''}${id}_${
      index + 1
    }`;
  };

  return {
    generateReference,
  };
}
